import React from 'react'
import Img from '../../../Img' // task #67: canonical image component
import Text from '../../../Text'
import HighlightedText from '../../../Utils/HighlightedText'
import { $background, $layer2, $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'
import StarFilled from '../../../icons/StarFilled'

function ProductTestimonialsV3({ titleHl, subtitleHl, racer1, racer2, racer3, racer4, brandLogo1, brandLogo2, brandLogo3, brandLogo4 }) {
  return (
    <>
      <section className="px-[5%] py-20 lg:py-40 hidden xl:flex flex-col items-center justify-center">
        <div className="container">
          <div className="text-center mb-12">
            { <HighlightedText {...titleHl}/> }
            { <HighlightedText {...subtitleHl}/> }
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 grid-rows-3 h-190">
            {/*Driver left tall card*/}
            <div className="row-span-2 bg-layer2-light rounded-[32px] overflow-hidden flex relative">
              <div className="absolute text-center top-2 w-full">
                <Text type="medium" color={$textTertiary.light}>{racer1.caption}</Text>
              </div>
              {/* Fill the tall card so the fill-mode <Img> has a real box.
                  Was `absolute bottom-0` (no width/height) -> the fill wrapper
                  collapsed to 0x0 and the photo never painted (blank tile).
                  reserveSpace={false} makes ImgWrapper width/height:100% (not an
                  aspect-ratio box) so the photo fills this bottom-anchored slot. */}
              <div className="absolute inset-x-0 bottom-0 h-full">
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={racer1.image}
                  alt={racer1.alt}
                  objectFit="contain"
                  reserveSpace={false}
                  className="w-full h-full flex"
                />
              </div>
            </div>

            {/*Logo*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo1) }
            </div>

            {/*Driver top small card */}
            <div className="bg-layer2-light rounded-[32px] overflow-hidden flex relative">
              <div className="absolute top-1/2 left-4 z-10">
                <Text type="medium" color={$textTertiary.light}>{racer4.caption}</Text>
              </div>
              {/* Was `absolute top-0 -right-2/5` (no size) -> 0x0. Give it the card
                  box so the fill <Img> paints; keep the intentional right bleed. */}
              <div className="absolute top-0 -right-2/5 h-full w-full">
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={racer4.image}
                  alt={racer4.alt}
                  objectFit="contain"
                  reserveSpace={false}
                  className="w-full h-full flex"
                />
              </div>
            </div>

            {/*Logo*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo2) }
            </div>

            {/*Center testimonial*/}
            { renderTestimonial() }

            {/*Driver Right tall card -->*/}
            <div className="row-span-2 bg-layer2-light rounded-[32px] overflow-hidden flex relative">
              <div className="absolute text-center top-2 w-full">
                <Text type="medium" color={$textTertiary.light}>{racer2.caption}</Text>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-full">
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={racer2.image}
                  alt={racer2.alt}
                  objectFit="contain"
                  reserveSpace={false}
                  className="w-full h-full flex"
                />
              </div>
            </div>

            {/*Logo -->*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo4) }
            </div>

            {/* Driver bottom small card -->*/}
            <div className="bg-layer2-light rounded-[32px] overflow-hidden flex relative">
              <div className="absolute top-1/2 right-4 z-10">
                <Text type="medium" color={$textTertiary.light}>{racer3.caption}</Text>
              </div>
              <div className="absolute top-0 -left-2/5 h-full w-full">
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={racer3.image}
                  alt={racer3.alt}
                  objectFit="contain"
                  reserveSpace={false}
                  className="w-full h-full flex"
                />
              </div>
            </div>

            {/*Logo*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo3) }
            </div>
          </div>
        </div>
      </section>
      <section className="p-[5%] py-20 py-16 xl:hidden flex flex-col items-center justify-center">
        <div className="container">
          <div className="text-center mb-12">
            { <HighlightedText {...titleHl}/> }
            { <HighlightedText {...subtitleHl}/> }
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 lg:gap-4 h-full">
            {/*Driver image*/}
            <div className="bg-layer2-light rounded-[32px] flex flex-col relative">
              { renderRacerMobile(racer1) }
            </div>
            {/*Driver image*/}
            <div className="bg-layer2-light rounded-[32px] flex flex-col relative">
              { renderRacerMobile(racer2) }
            </div>
            {/*Driver image*/}
            <div className="bg-layer2-light rounded-[32px] flex flex-col relative">
              { renderRacerMobile(racer3) }
            </div>
            {/*Driver image*/}
            <div className="bg-layer2-light rounded-[32px] flex flex-col relative">
              { renderRacerMobile(racer4) }
            </div>

            {/*Center testimonial*/}
            { renderTestimonial('medium', 'heading-7', 'small') }

            {/*Logo*/}
            <div className="px-4 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo1) }
            </div>

            {/*Logo*/}
            <div className="bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo2) }
            </div>

            {/*Logo*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo3) }
            </div>

            {/*Logo -->*/}
            <div className="p-8 bg-gray-100 rounded-2xl flex items-center justify-center">
              { renderLogo(brandLogo4) }
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

function renderRacerMobile(racer) {
  return (
    <>
      <div className="bg-layer2-light rounded-[32px] overflow-hidden flex flex-col relative">
        <div className="text-center mt-1 w-full">
          <Text type="medium" color={$textTertiary.light}>{racer.caption}</Text>
        </div>
        <div className="bottom-0 h-full">
          {/* task #67: descriptor via <Img> */}
          <Img
            image={racer.image}
            alt={racer.alt}
            objectFit="cover"
            className="w-full h-full object-cover flex aspect-square"
          />
        </div>
      </div>
    </>
  )
}

function renderLogo(logo) {
  // task #67: descriptor via <Img>
  return <Img
    image={logo.image}
    alt={logo.alt}
    objectFit="contain"
    className="contain aspect-square"
  />
}

function renderTestimonial(quoteTextType, titleTextType, subtitleTextType) {
  return (
    <div className="md:col-span-4 col-span-2 xl:col-span-2 bg-white rounded-2xl shadow p-6 flex flex-col gap-4 text-center">
      <div className="flex items-center justify-center space-x-1">
        { [...Array(5)].map((item, i) => <StarFilled key={'star-' + i}/>) }
      </div>
      <Text type={quoteTextType || 'large'}>
        { '"Using VRS equipment has helped me prepare for my race weekends and has made a hugely positive difference."' }
      </Text>
      <div>
        <Text type={titleTextType || 'heading-7'}>Frankie Mossman</Text>
        <Text type={subtitleTextType || 'regular'}>Indy Pro 2000</Text>
      </div>
    </div>
  )
}

export default ProductTestimonialsV3
